/**
 * Prefix a path with the API base for RAW fetch() calls that bypass the ky
 * client (api.ts). The ky client already uses VITE_API_BASE via prefixUrl;
 * raw fetches (file upload, authed images) must use this helper so they hit the
 * Fly API, not the static Pages origin.
 *
 * - dev: VITE_API_BASE unset → "" → relative path (vite dev proxy handles /api)
 * - prod: VITE_API_BASE = https://app.dfa.web.id → absolute
 * - already-absolute URLs (http/https) are returned unchanged
 */
export const apiUrl = (path: string): string => {
  if (/^https?:\/\//i.test(path)) return path;
  const base = import.meta.env.VITE_API_BASE ?? "";
  return `${base}${path}`;
};
